import React from 'react'

const RatingsGuideIcon = () => {
	return (
		<svg width={66} height={47} viewBox='0 0 66 47' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M55.596 12.289a18.608 18.608 0 00-6.484-5.144 18.72 18.72 0 00-8.087-1.835h-.048c-2.811 0-5.586.632-8.117 1.849a18.612 18.612 0 00-6.495 5.18l-.02.026-.02.024-1.913-1.308.016-.02.014-.018a20.925 20.925 0 017.331-5.924A21.052 21.052 0 0140.977 3h.048c3.18 0 6.318.72 9.177 2.104a20.926 20.926 0 017.322 5.887l-1.928 1.298z'
				fill='url(#paint0_linear_970:4766)'
			/>
			<path
				d='M55.586 12.279l.007.01a18.39 18.39 0 014.082 11.443c-.067 8.822-6.362 16.198-14.721 17.988-1.269.272-.917 2.561.516 2.252 9.345-2.014 16.39-10.237 16.527-20.09v-.028-.122-.156a20.676 20.676 0 00-4.471-12.575l-1.94 1.278z'
				fill='url(#paint1_linear_970:4766)'
			/>
			<path
				d='M24.477 10.991A20.674 20.674 0 0020 23.571V23.877c.137 9.852 7.182 18.069 16.527 20.089 1.438.315 1.786-1.975.52-2.247-8.36-1.79-14.655-9.165-14.724-17.987a18.39 18.39 0 014.084-11.443v-.01l-1.93-1.288z'
				fill='url(#paint2_linear_970:4766)'
			/>
			<path
				d='M39.52 29.205c.022-1.28.166-2.292.433-3.034.267-.743.812-1.566 1.635-2.47l2.1-2.178c.898-1.023 1.346-2.12 1.346-3.293 0-1.13-.293-2.012-.881-2.647-.588-.646-1.443-.968-2.565-.968-1.09 0-1.966.29-2.629.871-.662.581-.994 1.361-.994 2.34H35c.021-1.743.636-3.147 1.843-4.212 1.219-1.076 2.8-1.614 4.745-1.614 2.02 0 3.59.549 4.713 1.646C47.434 14.733 48 16.23 48 18.133c0 1.883-.866 3.74-2.597 5.568l-1.747 1.744c-.78.871-1.17 2.125-1.17 3.76H39.52zm-.128 5.117c0-.485.144-.888.433-1.211.3-.334.737-.5 1.314-.5.577 0 1.015.166 1.315.5.299.323.449.726.449 1.21 0 .485-.15.888-.45 1.21-.299.313-.737.469-1.314.469-.577 0-1.015-.156-1.314-.468-.289-.323-.433-.726-.433-1.21z'
				fill='#082DE8'
			/>
			<defs>
				<linearGradient
					id='paint0_linear_970:4766'
					x1={24.4062}
					y1={7.69519}
					x2={57.5284}
					y2={7.69519}
					gradientUnits='userSpaceOnUse'
				>
					<stop offset={0.09} stopColor='#A2FBD0' />
					<stop offset={0.9} stopColor='#FF5AF9' />
				</linearGradient>
				<linearGradient
					id='paint1_linear_970:4766'
					x1={47.5954}
					y1={45.1493}
					x2={61.8631}
					y2={12.9129}
					gradientUnits='userSpaceOnUse'
				>
					<stop offset={0.15} stopColor='#FF4856' />
					<stop offset={0.86} stopColor='#FF5AF9' />
				</linearGradient>
				<linearGradient
					id='paint2_linear_970:4766'
					x1={34.4045}
					y1={45.1493}
					x2={20.1368}
					y2={12.9129}
					gradientUnits='userSpaceOnUse'
				>
					<stop offset={0.13} stopColor='#082DE8' />
					<stop offset={0.86} stopColor='#A2FBD0' />
				</linearGradient>
			</defs>
		</svg>
	)
}

export default RatingsGuideIcon
